export default "__VITE_ASSET__CpbYnAde__"